/** @file Guard: a generated socket bone never becomes the parent of a user bone. */
import type { Doc, Id } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';

/** VALIDATION at `parent` when `parent` is a generated socket bone: socket.delete removes its subtree with it. */
export function assertUserParent(doc: Doc, parent: Id): void {
  if (doc.bones[parent]?.kind !== undefined) {
    throwError('VALIDATION', undefined, { path: 'parent', hint: 'generated socket bone: put the bone under the socket parentBone instead (socket.delete removes everything below it)' });
  }
}
